import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  children: string
}

function TD({ children, className }: Props) {
  return (
    <td
      className={cx(
        "text-sm",
        "text-normal",
        "text-gray-dark",
        "text-left",
        "py-5",
        "px-4",
        className
      )}
    >
      {children}
    </td>
  )
}

export default TD
